'use client';

import { ReactNode } from 'react';
import { cn } from '@shared/shared-utils';
import IconCheckmark from '../../../../../../../../../../../../public/svg/find-professional/icon-checkmark.svg';

type Properties = {
  woundIllustration: ReactNode;
  caption: string;
  onClick?: () => void;
  isSelected?: boolean;
};

const WoundLocationItem = ({
  woundIllustration,
  caption,
  onClick,
  isSelected = false,
}: Properties) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center h-full gap-y-8 lg:gap-y-14 cursor-pointer select-none',
      )}
      onClick={onClick}
    >
      <div
        className={cn(
          'relative w-[216px] h-[230px] flex items-end justify-center',
          {
            'text-[rgba(245,196,68,0.15)]': !isSelected,
            'text-[#F5C444]': isSelected,
          },
        )}
      >
        {woundIllustration}
        {isSelected && (
          <IconCheckmark className="absolute right-0 bottom-0 w-[66px] h-[66px]" />
        )}
      </div>
      <h5 className="text-[28px] text-ogn-blue font-bold max-w-[210px] text-center">
        {caption}
      </h5>
    </div>
  );
};

export { WoundLocationItem };
